import { Link } from "react-router-dom";
import { useState } from "react";

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  const closeAll = () => {
    setMenuOpen(false);
    setDropdownOpen(false);
  };

  return (
    <header>
      <div className="header-bg"></div>

      <div className="logo">
        <div className="logo1">
          <img src="pics/bnt.png" alt="BNT Logo" />
        </div>
        <div className="logo2">
          <h1>
            <span className="green">BRODKAST </span>
            <span className="white">NG </span>
            <br /> {/* This creates the second line */}
            <span className="white">TALINO </span>
            <span className="green">2026 </span>
          </h1>
        </div>
      </div>

      <button
        className={`nav-toggle${menuOpen ? " open" : ""}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle navigation"
        aria-expanded={menuOpen}
      >
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav className={`navbar${menuOpen ? " open" : ""}`}>
        <Link to="/" onClick={closeAll}>Home</Link>

        <div className={`dropdown${dropdownOpen ? " open" : ""}`}>
          <button
            className="nav-btn"
            onClick={() => setDropdownOpen(!dropdownOpen)}
          >
            About
          </button>
          <div className="dropdown-menu">
            <Link to="/Schools" onClick={closeAll}>List of Schools</Link>
            <Link to="/Champions" onClick={closeAll}>List of Champions</Link>
            <Link to="/Mechanics" onClick={closeAll}>Quiz Show Mechanics</Link>
            <Link to="/Packages" onClick={closeAll}>Packages</Link>
          </div>
        </div>

        <Link to="/Qualifications#qualifications" onClick={closeAll}>Qualifications </Link>
        <Link to="/Qualifications#registration" onClick={closeAll}>Registration</Link>

        <Link to="/Scoreboard" onClick={closeAll}>Scoreboard</Link>

        <Link to="/MiniGames" className="nav-link-style" onClick={closeAll}>Mini Games</Link>
      </nav>
    </header>
  );
}